import { render } from "./Equipment_button.vue?vue&type=template&id=531e492d&scoped=true"
import script from "./Equipment_button.vue?vue&type=script&lang=js"
export * from "./Equipment_button.vue?vue&type=script&lang=js"

import "./Equipment_button.vue?vue&type=style&index=0&id=531e492d&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-531e492d"]])

export default __exports__